/**
 * The default time to live for content steering in seconds.
 *
 * @group Content Steering
 *
 * @beta
 */
export const DEFAULT_TTL = 300;
//# sourceMappingURL=DEFAULT_TTL.js.map